export default __webpack_public_path__ + "static/media/koukou.61ac994e.jpg";